// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Q4k","expireSoon":"styles_expireSoon__3-oE0"};